import {Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild} from '@angular/core';
import {KEY_CODE} from '@catmodules/core/utils/index';
import {ExplorerItem} from '@catmodules/ui-base/types';

const componentBaseName = 'explorer-toolbar';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

/**
 * This component is used to provide helper options in combination with a tree navigation, in context of the {@link ExplorerComponent}
 *
 * It provides the options to:
 * - display a button that can be used to trigger processes for adding or creating something
 * - display a button to toggle a input field that can be used to start a typeahead search. e.g. on the associated {@link TreeComponent}
 */
@Component({
  selector: 'cat-explorer-toolbar',
  templateUrl: './explorer-toolbar.component.html',
  styleUrls: ['./explorer-toolbar.component.scss'],
})
export class ExplorerToolbarComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() enableSearch;
  @Input() displayCreate = true;
  @Input() displaySearchBox = false;
  @Output() searchHandler = new EventEmitter<string>();
  @Output() onSearchToggle = new EventEmitter<boolean>();
  @Output() onAddOrCreate = new EventEmitter<ExplorerItem>();

  @ViewChild('searchFilterInput') searchFilterInput: ElementRef;

  constructor() {
  }

  /**
   * This method is used on the 'plus' control. It can emit anything provided through the ::onAddOrCreate Output property
   */
  onAddOrCreateClick() {
    this.onAddOrCreate.emit();
  }

  /**
   * This method is used on the 'search' control.
   * Based on the current state of the related search-input it will toggle it's avaibility.
   * When hiding the input element, all things related with the serach-input is tryed to be reset.
   */
  doToggleSearch() {
    this.displaySearchBox = !this.displaySearchBox;
    if (this.displaySearchBox) {
      this.displaySearch();
    } else {
      this.resetSearch();
    }
  }

  /**
   * Initiate to clear the search input
   */
  doClearInput($event) {
    this.clearSearch();
  }

  /**
   * When entering a valid character the provided external callback to handle a search is emitted.
   * When pushing the ESC key, the whole search box will be reset.
   * @param $event
   */
  onChangeSearchTerm($event) {
    const keyboardEvent = $event as KeyboardEvent;

    if (keyboardEvent.keyCode === KEY_CODE.escape) {
      this.resetSearch();
    } else {
      this.searchHandler.emit($event.target.value);
    }
  }

  /**
   * Displays the search input field.
   * Set the current browser focus on the input field after a short delay.
   * The delay is required because of a rendering delay of angular itself
   */
  private displaySearch() {
    this.displaySearchBox = true;
    setTimeout(() => this.searchFilterInput.nativeElement.focus(), 100);
    this.onSearchToggle.emit(this.displaySearchBox);
  }

  /**
   * Hides the search input and initiates the cleanup-process
   */
  private resetSearch() {
    this.displaySearchBox = false;
    this.clearSearch();
    this.onSearchToggle.emit(this.displaySearchBox);
  }

  /**
   * Clears the current input value from the search input field
   * Emits the search hadler callback with an empty string
   */
  public clearSearch() {
    this.searchFilterInput.nativeElement.value = '';
    this.searchHandler.emit('');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/explorer/components/explorer-toolbar/explorer-toolbar.component.ts